module.exports = __webpack_public_path__ + "img/panelView_2_1.b51c6d6c.png";